(function () {
  function init(root) {
  if (!root || root.dataset.fcpInit === '1') return;
  root.dataset.fcpInit = '1';

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var storageKey = root.dataset.storageKey;
  var picksNeeded = parseInt(root.dataset.picks, 10) || 3;
  var delayMs = (parseFloat(root.dataset.delay) || 0) * 1000;
  var freqDays = parseInt(root.dataset.frequency, 10) || 30;
  var prizeMode = root.dataset.prizeMode || 'fixed';

  var prizes = [];
  try {
    var raw = root.querySelector('script[data-fcp-prizes]');
    prizes = JSON.parse(raw.textContent) || [];
  } catch (e) { prizes = []; }
  if (!prizes.length) prizes = [{ label: '15% OFF', code: 'FACE15', weight: 1 }];

  var steps = {};
  root.querySelectorAll('[data-fcp-step]').forEach(function (el) { steps[el.dataset.fcpStep] = el; });

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fcp-card]'));
  var counter = root.querySelector('[data-fcp-counter]');
  var form = root.querySelector('[data-fcp-form]');
  var input = form ? form.querySelector('input[type="email"]') : null;
  var submit = root.querySelector('[data-fcp-submit]');
  var errorEl = root.querySelector('[data-fcp-error]');
  var prizeLabelEl = root.querySelector('[data-fcp-prize-label]');
  var codeEl = root.querySelector('[data-fcp-code]');
  var copyBtn = root.querySelector('[data-fcp-copy]');
  var copyHint = root.querySelector('[data-fcp-copy-hint]');

  var picked = 0;
  var chosenPrize = null;
  var lastFocus = null;
  var fired = false;

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function suppressed() {
    if (designMode) return false;
    var seen = load(storageKey + ':seen');
    if (!seen) return false;
    var ageDays = (Date.now() - parseInt(seen, 10)) / 86400000;
    return ageDays < freqDays;
  }

  function pickPrize() {
    if (prizeMode === 'fixed') return prizes[0];
    var total = prizes.reduce(function (s, p) { return s + (p.weight || 1); }, 0);
    var roll = Math.random() * total;
    for (var i = 0; i < prizes.length; i++) {
      roll -= (prizes[i].weight || 1);
      if (roll <= 0) return prizes[i];
    }
    return prizes[0];
  }

  function show(name) {
    Object.keys(steps).forEach(function (k) { steps[k].hidden = (k !== name); });
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    // requestAnimationFrame gives the CSS transition a frame to start from.
    // It is paused on a backgrounded tab, so a timeout backs it up; otherwise
    // the overlay could sit un-hidden but fully transparent, swallowing clicks.
    var reveal = function () { root.classList.add('is-open'); };
    requestAnimationFrame(reveal);
    setTimeout(reveal, 100);
    document.documentElement.style.overflow = 'hidden';
    if (!designMode) store(storageKey + ':seen', String(Date.now()));
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCounter() {
    if (!counter) return;
    var left = picksNeeded - picked;
    counter.textContent = left > 0 ? (left + (left === 1 ? ' pick left' : ' picks left')) : '';
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (card.classList.contains('is-picked') || picked >= picksNeeded) return;

      // The prize is settled on the first pick so every card flips to the same face
      if (!chosenPrize) {
        chosenPrize = pickPrize();
        if (prizeLabelEl) prizeLabelEl.textContent = chosenPrize.label;
        if (codeEl) codeEl.textContent = chosenPrize.code;
      }

      var back = card.querySelector('[data-fcp-card-prize]');
      if (back) back.textContent = chosenPrize.label;

      card.classList.add('is-picked');
      card.disabled = true;
      picked++;
      updateCounter();

      if (picked >= picksNeeded) {
        cards.forEach(function (c) { c.disabled = true; });
        setTimeout(function () {
          show('reveal');
          if (input) input.focus();
        }, 1100);
      }
    });
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input) return;
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.hidden = false; }
        return;
      }
      if (errorEl) errorEl.hidden = true;
      if (submit) { submit.disabled = true; submit.textContent = 'One moment...'; }

      var body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'newsletter,popup-game');

      fetch('/contact', { method: 'POST', body: body, headers: { 'Accept': 'text/html' } })
        .then(function () { finish(email); })
        .catch(function () { finish(email); });
    });
  }

  function finish(email) {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      try { window.klaviyo.identify({ email: email }); } catch (e) {}
    }
    if (!designMode) store(storageKey + ':captured', '1');
    show('done');
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = codeEl ? codeEl.textContent : '';
      if (!code) return;
      var done = function () {
        if (!copyHint) return;
        var original = copyHint.textContent;
        copyHint.textContent = 'Copied';
        setTimeout(function () { copyHint.textContent = original; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else { done(); }
    });
  }

  root.querySelectorAll('[data-fcp-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  var scrim = root.querySelector('[data-fcp-scrim]:not([data-fcp-scrim-inert])');
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  updateCounter();
  show('game');

  /* Anything on the page carrying data-fc-open-popup reopens this, ignoring
     the frequency rule. That is how the persistent offer tab works: a visitor
     who dismissed the popup, or who has already seen it this fortnight, can
     still choose to come back to it. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-fc-open-popup]') : null;
    if (!trigger) return;
    e.preventDefault();
    fired = true;
    picked = 0;
    chosenPrize = null;
    cards.forEach(function (c) {
      c.classList.remove('is-picked');
      c.disabled = false;
      var back = c.querySelector('[data-fcp-card-prize]');
      if (back) back.textContent = '';
    });
    updateCounter();
    show('game');
    open();
  });

  if (designMode) { open(); return; }
  // ?nopopup=1 on any URL suppresses it. Useful for screenshots and for
  // showing someone the page without the popup landing on them.
  if (/[?&]nopopup/.test(window.location.search)) return;
  if (suppressed()) return;
  if (load(storageKey + ':captured') === '1') return;

  /* ---------------------------------------------------------------------
     Triggers. Any of the three can open the popup; whichever happens first
     wins and the rest are torn down, so a visitor never gets it twice.
     --------------------------------------------------------------------- */
  var teardown = [];

  function fire() {
    if (fired) return;
    fired = true;
    teardown.forEach(function (off) { try { off(); } catch (e) {} });
    teardown = [];
    open();
  }

  // 1. Time on page
  if (root.dataset.triggerDelay === 'true') {
    if (delayMs > 0) {
      var delayTimer = setTimeout(fire, delayMs);
      teardown.push(function () { clearTimeout(delayTimer); });
    } else {
      fire();
    }
  }

  // 2. Scroll depth
  if (!fired && root.dataset.triggerScroll === 'true') {
    var depth = parseInt(root.dataset.scrollDepth, 10) || 50;
    var lastCheck = 0;
    // Throttled on a timestamp rather than requestAnimationFrame, because rAF
    // is paused while a tab is in the background and the check would stall.
    var onScroll = function () {
      var now = Date.now();
      if (now - lastCheck < 120) return;
      lastCheck = now;
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = ((window.pageYOffset || doc.scrollTop) / scrollable) * 100;
      if (pct >= depth) fire();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    teardown.push(function () { window.removeEventListener('scroll', onScroll); });
  }

  // 3. Exit intent. Desktop pointers only, since a phone has no cursor to track.
  if (!fired && root.dataset.triggerExit === 'true' &&
      window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) {
    var armed = false;
    // Do not fire on the flick of the mouse that happens as a page loads.
    var armTimer = setTimeout(function () { armed = true; }, 3000);
    var onLeave = function (e) {
      if (!armed) return;
      if (e.clientY > 0) return;                    // only the top edge counts
      if (e.relatedTarget || e.toElement) return;   // cursor is still on the page
      fire();
    };
    document.addEventListener('mouseout', onLeave);
    teardown.push(function () {
      clearTimeout(armTimer);
      document.removeEventListener('mouseout', onLeave);
    });
  }
  }

  function boot() {
    document.querySelectorAll('[data-fcp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a merchant edits the section in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();
